
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"38","height":"38","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('path',{attrs:{"d":"M27.755 19.502c-.008.214-.089.461-.224.618L23.12 25.2c-.299.29-.873.41-1.207.074-.33-.331-.32-.974.009-1.306l3.101-3.569H10.935c-.457 0-.827-.401-.827-.896 0-.496.37-.897.827-.897h14.088l-3.101-3.568c-.283-.306-.334-.972-.009-1.308.326-.335.92-.228 1.207.075l4.412 5.08a.91.91 0 01.223.617","fill":"#FFF"}}),_c('path',{attrs:{"d":"M19.216 1.57c9.746 0 17.647 7.9 17.647 17.646s-7.9 17.647-17.647 17.647c-9.746 0-17.647-7.9-17.647-17.647C1.57 9.47 9.47 1.57 19.216 1.57z","stroke":"#FFF","stroke-width":"1.5"}})])])
          )
        }
      }
    